import { Injectable } from '@angular/core';
import { Pagination } from 'src/app/domain/pagination';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PaginationApi } from '../../domain/pagination-api';
import { Notification } from '../../domain/notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  url: string = `${environment.BASE_URL}/notification`;
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  });

  constructor(private http: HttpClient) {}

  getAllNotification() {
    return this.http.get(`${this.url}`, {
      responseType: 'json',
    });
  }

  getNotificationsPaginated(
    page: number,
    perPage: number,
    unread: boolean = false
  ): Observable<PaginationApi<Notification>> {
    return this.http.get<PaginationApi<Notification>>(`${this.url}/paginate`, {
      headers: this.httpHeaders,
      params: new HttpParams({
        fromObject: {
          page: page ? page.toString() : '',
          per_page: perPage ? perPage.toString() : '',
          unread: unread.toString(),
        },
      }),
    });
  }

  updateToRead(id: number) {
    return this.http.post(`${this.url}/${id}`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
}
